import { SplitByCharacter } from 'src/helper/splitByCharacter'

export const getIdsfromShortName = (listObjects, listNames) => {
    let listIds = []
    listObjects.forEach((item) => {
      listNames.forEach((names) => {
        if (item.short_name === names) {
          listIds.push(item.id)
        }
      })
    })
    return listIds
}
  
export const getIdsfromShortNameAndLongName = (listOptions, listNames) => {
    let listIds = []
    listOptions.forEach((item) => {
      listNames.forEach((names) => {
        if (item.short_name === SplitByCharacter(names, ' -')) {
          listIds.push(item.id)
        }
      })
    })
    return listIds
}
